import {createSelector} from 'reselect';

import {getCurrentUserStatus} from 'features/users/selectors/get_current_user_status';
import {UserStatuses} from 'utils/constants';

export const isCurrentUserNotAvailable = createSelector(
    getCurrentUserStatus,
    (status) => status === UserStatuses.DND || status === UserStatuses.OUT_OF_OFFICE,
);
